import { ContactRound, Instagram } from "lucide-react";
import Style from "../index.module.css";
import Masks from "../../../utils/masks";

export default function Step2({ formData, handleChange, errors, prevStep, nextStep }) {
  return (
    <div className={Style.step}>
      <h2 style={{ marginBottom: "4px" }}><ContactRound style={{ marginRight: '8px' }} /> Contatos</h2>
      <p style={{ fontSize: "10pt", marginBottom: "8px" }}>
        Informe os contatos que devem receber nossas atualizações.
      </p>

      <input 
        type="text"
        name="contatoCliente"
        placeholder="Digite um nome para Contato *"
        value={formData.contatoCliente}
        onChange={handleChange}
      />
      {errors.contatoCliente && <span className="error">{errors.contatoCliente}</span>}

      <input
        type="email"
        name="emailPrincipal"
        placeholder="Digite seu Email Principal *"
        value={formData.emailPrincipal}
        onChange={handleChange}
      />
      {errors.emailPrincipal && <span className="error">{errors.emailPrincipal}</span>}

      <input
        type="email"
        name="emailSecundario"
        placeholder="Digite seu Email Secundário *"
        value={formData.emailSecundario}
        onChange={handleChange}
      />
      {errors.emailSecundario && <span className="error">{errors.emailSecundario}</span>}

      <input
        type="text"
        name="telefonePrincipal"
        placeholder="Digite seu Telefone Principal *"
        value={formData.telefonePrincipal}
        onChange={(e) => {
          let value = Masks.telefone(e.target.value);
          handleChange({ target: { name: 'telefonePrincipal', value } });
        }}
      />
      {errors.telefonePrincipal && <span className="error">{errors.telefonePrincipal}</span>}

      <input
        type="text"
        name="telefoneSecundario"
        placeholder="Digite seu Telefone Secundário *"
        value={formData.telefoneSecundario}
        onChange={(e) => {
          let value = Masks.telefone(e.target.value);
          handleChange({ target: { name: 'telefoneSecundario', value } });
        }}
      />
      {errors.telefoneSecundario && <span className="error">{errors.telefoneSecundario}</span>}
      
      <h2 style={{ marginBottom: "4px", marginTop: "25px"}}>< Instagram style={{ marginRight: '8px' }} /> Redes Sociais</h2>
      <p style={{ fontSize: "10pt", marginBottom: "8px" }}>
        Informe suas redes sociais.
      </p>

      <input
        type="url"
        name="siteEmpresa"
        placeholder="Digite o Site da sua empresa"
        value={formData.siteEmpresa}
        onChange={handleChange}
      />
      {errors.siteEmpresa && <span className="error">{errors.siteEmpresa}</span>}

      <select
        name="redeSocial"
        value={formData.redeSocial}
        onChange={handleChange}
      >
        <option value="" disabled>Escolha a Rede Social</option>
        <option value="N/A">N/A Rede Social</option>
        <option value="instagram">Instagram</option>
        <option value="facebook">Facebook</option>
        <option value="twitter">Twitter</option>
      </select>
      {errors.redeSocial && <span className="error">{errors.redeSocial}</span>}

      <input
        type="text"
        name="perfilRedeSocial"
        placeholder="Link ou perfil da rede social"
        value={formData.perfilRedeSocial}
        onChange={handleChange}
      />
      {errors.perfilRedeSocial && <span className="error">{errors.perfilRedeSocial}</span>}

      <div className={Style.buttonGroup}>
        <button
          type="button"
          className={`${Style.button} ${Style.buttonSecondary}`}
          onClick={prevStep}
        >
          Voltar
        </button>
        <button
          type="button"
          className={`${Style.button} ${Style.buttonPrimary}`}
          onClick={nextStep}
        >
          Próximo
        </button>
      </div>
    </div>
  );
}
